export const FileEncodingEnum = {
  Default: 0,
  ASCII: 1,
  BigEndianUnicode: 2,
  Unicode: 3,
  UTF7: 4,
  UTF8: 5,
  UTF32: 6,
};

export const FileEncodingOptions = [
  {
    value: FileEncodingEnum.Default,
    key: FileEncodingEnum.Default,
    text: 'Default',
  },
  {
    value: FileEncodingEnum.ASCII,
    key: FileEncodingEnum.ASCII,
    text: 'ASCII',
  },
  {
    value: FileEncodingEnum.BigEndianUnicode,
    key: FileEncodingEnum.BigEndianUnicode,
    text: 'Big Endian Unicode',
  },
  {
    value: FileEncodingEnum.Unicode,
    key: FileEncodingEnum.Unicode,
    text: 'Unicode',
  },
  {
    value: FileEncodingEnum.UTF7,
    key: FileEncodingEnum.UTF7,
    text: 'UTF-7',
  },
  {
    value: FileEncodingEnum.UTF8,
    key: FileEncodingEnum.UTF8,
    text: 'UTF-8',
  },
  {
    value: FileEncodingEnum.UTF32,
    key: FileEncodingEnum.UTF32,
    text: 'UTF-32',
  },
];



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/FileEncodingEnum.js